import React from 'react';
import ReactDOM from 'react-dom';
import App from "./App";
import './core/i18n/i18n'

import './core/style/brand.css';
import './index.css';
import './core/style/soft-theme.css';
import { startVersionWatch } from "./core/service/VersionWatcher";
import { loadBranding } from "./core/service/branding-service";
import { applyAntdThemeToStaticApis } from "./core/style/antd-theme";

// Modal.confirm / message / notification React ağacının DIŞINDA render edilir; temayı oradan da
// bağlamazsak onay modallarındaki birincil buton antd'nin fabrika mavisinde kalır (marka slate'i değil).
applyAntdThemeToStaticApis();

/**
 * Açılış sırası:
 *   1) configuration.json → YALNIZ altyapı (API adresi, sekme davranışı). Bunlar ortama özeldir,
 *      DB'den okunamaz (DB'ye ulaşmak için zaten API adresi gerekir).
 *   2) /api/PublicBranding/Get → marka (logo, favicon, başlık). Beyaz etiket verisi artık DB'de;
 *      configuration.json'daki eski `theme` bloğu kullanılmaz (sunucuda kalsa da zararsızdır).
 *
 * Marka yüklemesi uygulamayı bloklamaz: API yoksa cache'e, o da yoksa gömülü varsayılana düşer.
 */
const loadRis = async () => {
    localStorage.setItem('recording', 'false');

    const res = await fetch('/configuration.json')
    const config = await res.json()
    window.AppSettings = {
        ...config
    }

    await loadBranding()

    ReactDOM.render(
        <App />,
        document.getElementById('root')
    );

    startVersionWatch();
}

loadRis()
